const serviceByMailStyle = Object.freeze({
  fontStack: 'alt',
});

export default serviceByMailStyle;
